<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center min-vh-100">
          <div class="w-100 d-block card shadow-lg rounded my-5 overflow-hidden">
            <div class="row">
              <div class="col-lg-5 d-none d-lg-block bg-login rounded-left" :style="getLoginBgStyle()"></div>
              <div class="col-lg-7">
                <div class="p-5">
                  <div class="text-start w-100 mx-auto auth-logo mb-4">
                    <a href="javascript:void(0)">
                      <span><img :src="getUrl(Profiles.Image, logo_default)" alt="logo"
                          class="mb-2 ms-md-0 ms-5 me-n5 me-md-0 avatar-lg" /></span>
                      <span class="fs-1 fw-bold ms-md-2 mt-2 text-nowrap">
                        <span v-for="(word, index) in getNameWords()" :key="index" :class="bootstrapColors[index % bootstrapColors.length]
                          " class="me-1">
                          {{ word }}
                        </span></span>
                    </a>
                  </div>
                  <h1 class="h5 mb-1">Welcome Back!</h1>
                  <p class="text-muted mb-4">
                    Enter your email address and password to access admin panel.
                  </p>
                  <div class="form-group mb-3">
                    <label class="form-label" for="emailaddress">Email address</label>
                    <input class="form-control" type="email" id="emailaddress" required=""
                      placeholder="Enter your email" v-model="email" />
                  </div>
                  <div class="form-group mb-3">
                    <a href="pages-recoverpw.html" class="text-muted float-end"><small></small></a>
                    <label class="form-label" for="password">Password</label>
                    <input type="password" class="form-control" required="" id="password"
                      placeholder="Enter your password" v-model="password" />
                  </div>
                  <div class="form-group mb-3">
                    <input class="form-check-input custom-checkbox cursor-pointer" role="button" type="checkbox"
                      id="checkbox-signin" v-model="rememberMe" />
                    <label class="form-check-label ms-2" for="checkbox-signin">
                      Remember me
                    </label>
                  </div>
                  <div class="form-group mb-0 text-center">
                    <button class="btn btn-darknavy w-100 mb-2" @click="login()">
                      <i class="fas fa-sign-in"></i> Log In
                    </button>
                    <span class="text-danger mt-5"> {{ errorMsg }} </span>
                  </div>
                  <div class="form-group mb-0 text-end">
                    <a :href="teacherLoginUrl" class="text-muted">
                      Teacher Login
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";
import { api } from "@/utils/helpers.js";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const teacherLoginUrl = `https://mobileapp.${window.location.hostname.split('.').slice(-2).join('.')}/`;
const router = useRouter();
const store = useStore();
const Profiles = ref({});
const email = ref("");
const password = ref("");
const rememberMe = ref(false);
const errorMsg = ref("");
const setToken = ref("");
const setUserID = ref("");
const logo_default = "/images/Logo.png";
const loginbanner_default = "/images/Login-Banner.jpg";
const bootstrapColors = [
  "text-danger",
  "text-warning",
  "text-success",
  "text-primary",
  "text-info",
  "text-secondary",
  "text-dark",
];
const getNameWords = () => {
  return Profiles.value?.Name ? Profiles.value.Name.split(" ") : [];
};
const getLoginBgStyle = () => {
  const fullUrl = getUrl(Profiles.value.loginBnr, loginbanner_default);
  return {
    backgroundImage: `url('${fullUrl}')`,
    backgroundSize: "fill",
  };
};
const loadProfiles = async () => {
  try {
    const response = await api.get(`/setting/all`);
    Profiles.value = response.data[0] || {};
  } catch (error) {
    console.error("Error loading Profile:", error);
  }
};
onMounted(() => {
  loadProfiles();
  const savedEmail = localStorage.getItem("rememberedEmail");
  const savedPassword = localStorage.getItem("rememberedPassword");
  if (savedEmail && savedPassword) {
    email.value = savedEmail;
    password.value = savedPassword;
    rememberMe.value = true;
  }
});
watch(rememberMe, (newValue) => {
  if (!newValue) {
    localStorage.removeItem("rememberedEmail");
    localStorage.removeItem("rememberedPassword");
  }
});
const login = async () => {
  await api
    .post("/users/login", {
      email: email.value,
      password: password.value,
    })
    .then((response) => {
      errorMsg.value = "";
      setToken.value = response.data.token;
      setUserID.value = response.data.userID;
      store.commit("setToken", response.data.token);
      store.commit("setUserID", response.data.userID);
      if (rememberMe.value) {
        localStorage.setItem("rememberedEmail", email.value);
        localStorage.setItem("rememberedPassword", password.value);
      }
      router.push("/dashboard");
    })
    .catch((error) => {
      errorMsg.value =
        error.response?.status == 401
          ? "Invalid Email / Password"
          : "Try Again After Sometime";
    });
};
const getUrl = (img, fallback) => {
  let imgUrl = !img ? fallback : img.startsWith("..") ? img.substring(2) : img;

  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
};
</script>
<style scoped>
.body {
  background-color: white !important;
}

.custom-checkbox {
  background-color: #242a5f !important;
}
</style>
